import { render, staticRenderFns } from "./LaborServiceTabs.vue?vue&type=template&id=57178f82&scoped=true&"
import script from "./LaborServiceTabs.vue?vue&type=script&lang=js&"
export * from "./LaborServiceTabs.vue?vue&type=script&lang=js&"
import style0 from "./LaborServiceTabs.vue?vue&type=style&index=0&id=57178f82&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57178f82",
  null
  
)

export default component.exports